<template>
  <div class="">
    <div v-if="is_connected">

      <TimeGraph
        :graph_settings_open="graph_settings_open"
        :graph_buffer="this.graph_buffer"
        @fill_channels="fillChannels()"
        @clear_channels="clearChannels()"
        @select_nodes="selectNodes()"
        @done_select_nodes="doneSelectNodes()"
        :series="channel_series"
        :fixed_width="this.graph_width_prop"
        :start_date="subscribe_time"
        :end_date="end_date"
        :fixed_height="this.graph_height_prop"
        :disable_zoom="true"
        :show_channel_controls="true"
        :autoshift="true"
        :unique_identifier="'g_2'"
        :firstYAxisLeft="false"
        :has_hold_values="true"
        :has_fill_channels="hasFillChannels"
        :has_select_nodes="hasSelectNodes"
        :zone="$app.sltd.zone"
        :nodes="nodes"
        :default_graph_description="defaultGraphDescription"
        :local_storage_id="localStorageId"
        :controller="controller"
        :select_mode="select_mode"
        @toggle-hidden-series="handleToggleHiddenSeries"
        @select-deselect-all-series="handleSelectDeselectAllSeries"
        @reset-graph-buffer="handleResetGraphBuffer"
        @set-hidden-series="handleSetHiddenSeries"
      />
    </div>
    <NoDataLabel v-else :text="disconnected_text" />
    <Section
      :title = "$txt.channels"
    >
      <ResponsiveTable>
        <template v-slot:head>
          <thead>
            <tr class="wm_left_cell">
              <th>{{ $txt.name }}</th>
              <th>{{ $txt.timestamp }}</th>
              <th>{{ $txt.live_value }}</th>
              <th>{{ $txt.unit }}</th>
              <th>{{ $txt.timestamp }}</th>
              <th>{{ $txt.held_value }}</th>
              <!-- TODO: hardcoded until the text key is added to the language files -->
              <th v-if="any_hold_value" :title="difference_hint">Difference</th>
            </tr>
          </thead>
        </template>
        <tbody class="wm_left_cell">
          <tr v-for="c in visible_channel_series" :key="c.no">
            <td>
              <span 
                class="colored-symbol" 
                :style="{ backgroundColor: c.color }"
              />
              {{ c.name || '' }}
            </td>
            <td>
              <span v-if="c.data && c.data.length && c.data[c.data.length-1].minDate">
                <TimeLabel :time="c.data[c.data.length-1].minDate" :show_seconds="true" />
              </span>
              <span v-else></span>
            </td>
            <td>
              <span v-if="c.data && c.data.length && c.data[c.data.length-1].value !== undefined">
                {{ fmt(c.data[c.data.length-1].value, c.decimals) }}
              </span>
              <span v-else></span>
            </td>
            <td>
              {{ c.unit || '' }}
            </td>
            <td>
              <span v-if="c.hold_value_timestamp">
                <TimeLabel :time="c.hold_value_timestamp" :show_seconds="true" />
              </span>
              <span v-else></span>
            </td>
            <td>
              <span v-if="c.hold_value !== undefined && c.hold_value !== null">
                {{ fmt(c.hold_value, c.decimals) }}
              </span>
              <span v-else></span>
            </td>
            <td v-if="any_hold_value">
              <span v-if="hold_difference(c) !== null">
                {{ fmt(hold_difference(c), c.decimals) }}
              </span>
              <span v-else></span>
            </td>
          </tr>
        </tbody>
      </ResponsiveTable>

    </Section>
   
  </div>

  
</template>

<script>
import { GraphData } from "@/api/graphdata.js";
const GraphBuffer = require("@/recordings/graphbuffer").default;
const Camur = require("@/utils/camurutils").default;
export default {
  name: "LiveValuesView",

  data() {
    return {
      graph_data: null,
      graph_buffer: new GraphBuffer(this.$app.sltd.project, this.graph_data),
      subscribe_time: 0,
      initial_url: "",
      series:null
    };
  },

  props: {
    graph_settings_open: {
      type: Boolean,
      default: null
    },
    graph_height_prop: {
      type: Number,
      default: 500
    },
    graph_width_prop: {
      type: Number,
      default: 1200
    },
    interval_s: {
      type: Number,
      default: 2
    },
    duration_s: {
      type: Number,
      default: 60
    },
    channels: {
      type: Array,
      default: null
    },
    live_vals: {
      type: Object,
      default: null
    },
    include_node_name: {
      type: Boolean,
      default: true
    },
    include_zone_name: {
      type: Boolean,
      default: false
    },
    held_vals: {
      type: Object,
      default: null
    },
    is_connected: {
      type: Boolean,
      default: true
    },
    disconnected_text: {
      type: String,
      default: "Not connected"
    },
    nodes: {
      type: Array,
      default: null
    },
    default_graph_description: {
      type: String,
      default: "Default graph description"
    },
    local_storage_id: {
      type: String,
      default: ""
    },
    controller: {
      type: Object,
      default: null      
    },
    select_mode: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.graph_data = new GraphData(this.$app, this.$appm.net);
    this.graph_data.graph_buffer = this.graph_buffer;
    this.initial_url = window.location.href;
    console.log("mounted");
    window.setTimeout(this.try_subscribe, 1500);
    window.setInterval(this.refresh, 5000);
    window.setTimeout(this.load_hold_values_from_localStorage, 1500);
    // console.log("channel series? ", this.channel_series)
  },

  methods: {
    fmt(v, d = 0) {
      const n = Number(v);
      if (!Number.isFinite(n)) return v;
      return n.toFixed(d).replace(".", this.$app.settings.decimal_point);
    },

    latest_live_value(c) {
      if (!c.data || !c.data.length) return null;
      const n = Number(c.data[c.data.length - 1].value);
      return Number.isFinite(n) ? n : null;
    },

    hold_difference(c) {
      if (c.hold_value === undefined || c.hold_value === null) return null;
      const held = Number(c.hold_value);
      const live = this.latest_live_value(c);
      if (!Number.isFinite(held) || live === null) return null;
      return held - live;
    },
    handleToggleHiddenSeries(seriesId, hide) {
      if (hide) {
        if (!this.graph_buffer.hidden_series.includes(seriesId)) {
          this.graph_buffer.hidden_series.push(seriesId);
        }
      } else {
        this.graph_buffer.hidden_series = this.graph_buffer.hidden_series.filter(id => id !== seriesId);
      }
      this.graph_buffer.state++;
    },
    handleSelectDeselectAllSeries(showAll) {
      if (showAll) {
        this.graph_buffer.hidden_series = [];
      } else {
        this.graph_buffer.hidden_series = this.series.map(s => s.id);
      }
      this.graph_buffer.state++;
    },
    handleResetGraphBuffer() {
      this.graph_buffer.reset();
      this.graph_buffer.state++;
    },
    handleSetHiddenSeries(hiddenSeries) {
      this.graph_buffer.hidden_series = hiddenSeries;
      this.graph_buffer.state++;
    },
    load_hold_values_from_localStorage() {
      if (this.$app.sltd.project && this.$app.sltd.project.all_nodes) {
        for (let node of this.$app.sltd.project.all_nodes) {
          if (
            !localStorage.hasOwnProperty("C3_Hold_"+node.cross_prj_identifier)
          ) {
            return;
          }
  
          let hold_val_json = localStorage["C3_Hold_"+node.cross_prj_identifier];
          node.app_prop.held_vals = JSON.parse(hold_val_json);
        }
      }
    },
    refresh() {
      // this.series = null;
    },
    try_subscribe() {
      //console.log("try_subscribe");
      let time_since_subscribe = Date.now() - this.subscribe_time;

      if (
        window.app.msg_manager.is_ready() &&
        (time_since_subscribe >= this.duration_s * 1000 ||
          window.app.msg_manager.connection_time > this.subscribe_time)
      ) {
          this.subscribe_nodes();
      }

      // If we are still on the same page
      if (window.location.href == this.initial_url) {
        // Test if we need to resubscribe again
        window.setTimeout(this.try_subscribe, 1500);
      }
    },
    hold_values() {
      console.log("LiveValuesView.hold_values");
      this.$emit("hold_values");
    },

    subscribe_nodes() {
      console.log("LiveValuesView.subscribe_nodes");
      this.subscribe_time = Date.now();
      this.$emit("subscribe", this.interval_s, this.duration_s);
    },
    fillChannels() {
      console.log("LiveValuesView.fill_channels");
      this.$emit("fill_channels");
    },
    clearChannels() {
      console.log("LiveValuesView.clear_channels");
      this.$emit("clear_channels");
    },
    selectNodes() {
      console.log("LiveValuesView.selectNodes");
      this.$emit("select_nodes");
    },
    doneSelectNodes() {
      console.log("LiveValuesView.doneSelectNodes");
      this.$emit("done_select_nodes");
    },
    sort_string(a) {
      // sortStr will provide a unique string id
      // with a defined sort-order
      let sortStr=a.name + "-" + (10000 + a.id);
      return sortStr;
    },

    channelSort(a, b) {
      const ioCmp = (a?.io ?? 99) - (b?.io ?? 99);
      if (ioCmp) return ioCmp;
      const noCmp = (a?.no ?? 9999) - (b?.no ?? 9999);
      if (noCmp) return noCmp;
      return (a?.id ?? 0) - (b?.id ?? 0);
    },

    sort_series_based_on_project_tree() {
      const sorted_channels = [];
      const pushNode = (node) => {
        const perNode = Object.values(node.channels || {}).sort(this.channelSort);
        sorted_channels.push(...perNode);
      };

      if (this.$app.sltd.zone) {
        const sorted_nodes = this.$util.sort_table(this.$app.sltd.zone.nodes, "sortIndex");
        for (const node of sorted_nodes) pushNode(node);
      } else if (this.$app.sltd.cntrl && !this.$app.sltd.zone) {
        const sorted_zones = this.$util.sort_table(this.$app.sltd.cntrl.zones, "sortIndex");
        for (const zone of sorted_zones) {
          const sorted_nodes = this.$util.sort_table(zone.nodes, "sortIndex");
          for (const node of sorted_nodes) pushNode(node);
        }
      } else if (this.$app.sltd.project && !this.$app.sltd.cntrl && !this.$app.sltd.zone) {
        const sorted_cntrls = this.$util.sort_table(this.$app.sltd.project.cntrls, "sortIndex");
        for (const cntrl of sorted_cntrls) {
          const sorted_zones = this.$util.sort_table(cntrl.zones, "sortIndex");
          for (const zone of sorted_zones) {
            const sorted_nodes = this.$util.sort_table(zone.nodes, "sortIndex");
            for (const node of sorted_nodes) pushNode(node);
          }
        }
      }

      return sorted_channels;
    },

    applySeriesOrderFrom(sorted_channels, seriesToSort) {
      const key = v => String(v);
      const wantedIds = new Set(seriesToSort.map(s => key(s.id)));
      const order = new Map();
      let rank = 0;
      for (const ch of sorted_channels) {
        const id = key(ch.id);
        if (wantedIds.has(id) && !order.has(id)) order.set(id, rank++);
      }
      const originalIndex = new Map(seriesToSort.map((s, i) => [key(s.id), i]));
      const INF = Number.POSITIVE_INFINITY;

      return [...seriesToSort].sort((a, b) => {
        const ra = order.has(key(a.id)) ? order.get(key(a.id)) : INF;
        const rb = order.has(key(b.id)) ? order.get(key(b.id)) : INF;
        return (ra - rb) || (originalIndex.get(key(a.id)) - originalIndex.get(key(b.id)));
      });
    },
  },

  computed: {
    visible_channel_series() {
      void this.graph_buffer?.state; // recompute when graph_buffer changes
      const hidden = this.graph_buffer?.hidden_series || [];
      return this.channel_series.filter(c => !hidden.includes(c.id));
    },
    end_date() {
      // twice as wide as the subscription duration
      return this.subscribe_time + this.duration_s * 2 * 1000;
    },

    any_hold_value() {
      return this.visible_channel_series.some(
        c => c.hold_value !== undefined && c.hold_value !== null
      );
    },

    difference_hint() {
      return `${this.$txt.held_value} - ${this.$txt.live_value}`;
    },

    local_held_vals() {
      //console.log("Fill held_vals");
      let result = {};
      for (let node of this.nodes) {
        for (let v in node.app_prop.held_vals ) {
           result[v] = node.app_prop.held_vals[v];
          //console.log("Held value:"+ result[v]); 
        }
      }
      return result;
    },

    defaultGraphDescription() {
      return this.default_graph_description;
    },   
    localStorageId() {
      return this.local_storage_id;
    },
    hasFillChannels() {
      // do not fill channels automatically if controller is selected
      return (this.controller != null);
    },
    hasSelectNodes() {
      // do not fill channels automatically if controller is selected
      return (this.controller == null) && (this.$app.sltd.zone == null);
    },
    channel_series() {
      console.log("channels.length:"+this.channels.length);
      let colors = this.$camur.get_series_color_scheme();
      let result = [];
      if (this.series != null) {
        result = this.series;
      }
      let color_index = 0;

      // Any series to be removed ?
      let removeCompleted = false;
      while (!removeCompleted) {
        removeCompleted = true;
        for (let serie of result) {
          let index = 0;
          let thisChannelObj = this.channels.find(ch => (ch.id == serie.id));
          if (thisChannelObj == null) {
            // Remove this serie
            result.splice(index);
            removeCompleted = false;
            console.log("Serie removed");
            break;
          }
        }
      }
  
      for (let channel of this.channels) {
        // console.log("this.channels", this.channels)
        if (channel.io == Camur.io_type.io_type_output) continue;
       
        let channel_identifier = `${channel.nodeId}_${channel.no}`
        let hold_value = null;
        let hold_value_timestamp = null;

        if (this.local_held_vals[channel_identifier] != null) {
          hold_value = this.local_held_vals[channel_identifier].value;
          hold_value_timestamp = this.local_held_vals[channel_identifier].minDate;
          //console.log("Hold value:"+hold_value);
        }
        
        let display_name = channel.name;


        let node = this.$appm.get_node_by_id(
            this.$app.sltd.prj_id,
            channel.nodeId,
           );

        if (this.include_node_name) {
          if (this.include_zone_name) {
            let zone = this.$appm.get_zone(
              this.$app.sltd.prj_id,
              node.dto.zoneId,
            );
            display_name = `${zone.name}-${node.name}-${channel.name}`;
          } else {
            display_name = `${node.name}-${channel.name}`;
          }
        }

        let data = this.live_vals[channel_identifier];
        
        if (data == null) {
          data = [];
        /*color_index += 1;
          continue; */
        } 

        /*if (data.length == 0) {
          color_index += 1;
          continue;
        }  */
        
        let thisSerieObj = null;

        if (result != null) {
          thisSerieObj = result.find(s => (s.id == channel.id));
        }
        
        if (thisSerieObj !=null) {
          thisSerieObj.hold_value = hold_value; 
          thisSerieObj.hold_value_timestamp = hold_value_timestamp;  
        }
        else {
          result.push({
            name: display_name,
            data: data,
            unit: channel.formula.unit,
            graph_min: channel.formula.graphScaleMin,
            graph_max: channel.formula.graphScaleMax,
            decimals: channel.formula.decimals,
            color: colors[color_index % colors.length],
            line: "linear",
            id: channel.id,
            hidden: true,
            hold_value: hold_value,
            hold_value_timestamp : hold_value_timestamp,
            channel_no: channel.no
          });
        }
        color_index += 1;
        
      }

      color_index =0;
        // re-assign colors after sort
      let rIndex=0;
      for (rIndex=0;rIndex < result.length ; rIndex++) {
        result[rIndex].color = colors[color_index % colors.length];
        color_index ++;
      }
      // eslint-disable-next-line
      this.series = result;
      color_index = 0

      let voltageChannels = []; // u
      let currentChannels = []; // i
      for (let serie of this.series) {
        // if (!this.graph_buffer.hidden_series.includes(serie.id)) {
          let channel = this.$app.sltd.project.find_channel(serie.id);
          let node = this.$app.sltd.project.find_node(channel.nodeId);
          if (node.is_power_supply) {
            if (channel.code === "U") {
              voltageChannels.push(channel);
            }
            else if (channel.code === "I") {
              currentChannels.push(channel)
            }
          }
        // }
      }
      let voltageCount = 0;
      let currentCount = 0;
      for (let serie of this.series) {
        let channel = this.$app.sltd.project.find_channel(serie.id);
        let node = this.$app.sltd.project.find_node(channel.nodeId);
        if (node.is_power_supply && (channel.code == "U" || channel.code == "I")) {
          if (channel.code == "U" && voltageCount < 1) {
            serie.color = "red"
            voltageCount ++;
          }
          if (channel.code == "I" && currentCount < 1) {
            serie.color = "blue"
            currentCount ++;
          }
        } else {
          serie.color = colors[color_index % colors.length];
          color_index ++;
        }
      }
      const sorted_channels = this.sort_series_based_on_project_tree();
      result = this.applySeriesOrderFrom(sorted_channels, result); 
      return result;
    },
  }
};
</script>
<style scoped>
.colored-symbol {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
</style>